import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgHomeIconInactive = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M18.3337 14.1673V9.87149C18.3337 8.69482 18.3337 8.10649 18.184 7.56329C18.0514 7.08208 17.8335 6.62859 17.5406 6.22446C17.2098 5.76828 16.7504 5.40074 15.8317 4.66569L14.165 3.33236C12.6787 2.1433 11.9355 1.54877 11.1113 1.32076C10.3843 1.11964 9.61632 1.11964 8.88932 1.32076C8.06518 1.54877 7.32202 2.1433 5.83569 3.33236L4.16903 4.66569C3.25021 5.40074 2.7908 5.76828 2.46011 6.22446C2.16716 6.62859 1.9492 7.08208 1.81663 7.56329C1.66699 8.10649 1.66699 8.69482 1.66699 9.87149V14.1673C1.66699 16.4685 3.53248 18.334 5.83366 18.334C6.75413 18.334 7.50033 17.5878 7.50033 16.6673V13.3339C7.50033 11.9532 8.61958 10.8339 10.0003 10.8339C11.3811 10.8339 12.5003 11.9532 12.5003 13.3339V16.6673C12.5003 17.5878 13.2465 18.334 14.167 18.334C16.4682 18.334 18.3337 16.4685 18.3337 14.1673Z",
		stroke: "currentColor",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgHomeIconInactive;
